import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsFamilySurvey,
  UpdateNpsFamilySurvey,
  FiltersNpsFamilySurveys,
  CreateNpsFamilySurveySetup
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsFamilySurveyResponse,
  ListNpsFamilySurveysResponse,
  NpsFamilySurveySetupResponse
} from '@/Network/Types/Responses/NpsResponses'
import { NpsPublicFormResponse } from '@/Network/Types/Responses/NpsPublicFormResponses'

export default class NpsFamilySurveyService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/family-surveys'
  }

  async create(payload: CreateNpsFamilySurvey): Promise<NpsFamilySurveyResponse> {
    const response = await request.post<NpsFamilySurveyResponse>(this.getCompletePath(), payload)
    return response.data
  }

  async update(surveyId: number, payload: UpdateNpsFamilySurvey): Promise<NpsFamilySurveyResponse> {
    const response = await request.put<NpsFamilySurveyResponse>(
      `${this.getCompletePath()}/${surveyId}`,
      payload
    )
    return response.data
  }

  async getById(surveyId: number): Promise<NpsFamilySurveyResponse> {
    const response = await request.get<NpsFamilySurveyResponse>(
      `${this.getCompletePath()}/${surveyId}`
    )
    return response.data
  }

  async delete(surveyId: number): Promise<void> {
    await request.delete(`${this.getCompletePath()}/${surveyId}`)
  }

  async setup(payload: CreateNpsFamilySurveySetup): Promise<NpsFamilySurveySetupResponse> {
    const response = await request.post<NpsFamilySurveySetupResponse>(
      `${this.getCompletePath()}/setup`,
      payload
    )
    return response.data
  }

  async getActiveSurveys(healthUnitId: number, surveyId?: number): Promise<NpsPublicFormResponse> {
    const params = surveyId ? { surveyId } : undefined
    const { data } = await request.get<NpsPublicFormResponse | NpsPublicFormResponse[]>(
      `${this.getCompletePath()}/active/health-unit/${healthUnitId}`,
      params
    )
    if (Array.isArray(data)) {
      if (data.length === 0)
        throw new Error('Nenhum formulário vigente encontrado para esta unidade.')
      return data[0]
    }
    return data
  }

  async list(filters?: FiltersNpsFamilySurveys): Promise<ListNpsFamilySurveysResponse> {
    try {
      const { data } = await request.get<ListNpsFamilySurveysResponse>(
        this.getCompletePath(),
        filters
      )
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
